<template>
  <section>
    <qx-search-box
      class="searchBox"
      ref="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery=""
    />
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  getEnumList,
} from 'api';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        billStateOptions: [], // 状态
        form: [
          { // 申请号码
            label: '申请号码',
            value: 'applyNum',
            type: 'input',
            placeholder: '请输入申请号码',
            default: this.$route.query.applyNum,
          },
          {
            label: '申请时间',
            value: 'dateTime',
            type: 'date',
            attr: {
              type: 'daterange',
            },
          },
          { // 发票号码
            label: '发票号码',
            value: 'invoiceNumber',
            type: 'input',
            placeholder: '请输入发票号码',
          },
          { // 快递单号
            label: '快递单号',
            value: 'expressNumber',
            type: 'input',
            placeholder: '请输入快递单号',
          },
          { // 状态
            label: '状态',
            value: 'billState',
            type: 'select',
            default: -1,
            placeholder: '请选择状态',
          },
        ],
      },
    };
  },
  watch: {
    '$route.query.applyNum': function (newVal) {
      if (this.$route.path === '/manage/operate/invoice/register') {
        this.$refs.searchBox.setVal('applyNum', newVal);
        this.$refs.searchBox.sub();
      }
    },
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      // 申请时间
      if (searchBoxData.dateTime && searchBoxData.dateTime[0]) {
        searchBoxData.dateTimeStart = this.formatDate(searchBoxData.dateTime[0], 1);
        searchBoxData.dateTimeEnd = this.formatDate(searchBoxData.dateTime[1], 1);
      }
      delete searchBoxData.dateTime;
      this.$refs.tableBox.saveSearchBoxData({
        sts: -1,
        type: 2,
        ...searchBoxData,
      });
    },
  },
  async created () {
    const enumsList = await getEnumList({
      codeType: 'INVOICE_STATE',
    });
    this.searchBoxData.billStateOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...enumsList[0],
    ];
  },
};
</script>

<style lang="scss" scoped>
</style>
